import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import { DEFAULT_ROWS, DEFAULT_ORDER } from '..';
import { detail, list, transfer } from './Operations.service';
import { StockTransferListRequest } from './Operations.types';
import { AxiosError } from 'axios';

export type ErrorStockTransfer = AxiosError<{
  message: string;
  name: string;
  description: string;
  fieldErrors: Record<string, string[]>;
}>;

export function useStockTransferList(
  params?: StockTransferListRequest,
  enabled = true,
) {
  return useInfiniteQuery(
    [['stock-transfer/list'], params],
    ({ pageParam }) =>
      list({
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.result.nextToken,
      enabled,
      onError(error) {
        notificationError(error, {
          message: 'Listagem de transferência de estoque',
          description: 'Não foi possível listar',
        });
      },
    },
  );
}

export function useStockTransfer() {
  const mutation = useMutation(transfer, {
    onSuccess() {
      notification.success({
        message: 'Sucesso!',
        description: 'Transferência de estoque feita com sucesso!',
      });
    },

    onError(error) {
      const axiosError = error as ErrorStockTransfer;

      notificationError(error, {
        translate: (errors) =>
          errors.map((err) => {
            return (
              axiosError.response?.data?.description ||
              axiosError.response?.data?.message ||
              err
            );
          }),
      });
    },
  });

  return mutation;
}

export function useStockTransferDetail(id?: number) {
  const result = useQuery(['stock-transfer/detail', id], () => detail(id), {
    enabled: !!id,
    onError(error) {
      notificationError(error);
    },
  });

  return result;
}
